module.exports = __webpack_public_path__ + "img/google-brands.3be1ce5d.svg";